import { render, staticRenderFns } from "./LessonItem.vue?vue&type=template&id=285c597c&"
import script from "./LessonItem.vue?vue&type=script&lang=js&"
export * from "./LessonItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports